import moment from 'moment';

export function useDateUtilities() {
  const getPeriodLabel = timeStr => {
    try {
      const [hh, mm] = (timeStr || '00:00')
        .split(':')
        .map(n => parseInt(n, 10));
      const total = (isNaN(hh) ? 0 : hh) * 60 + (isNaN(mm) ? 0 : mm);
      if (total < 6 * 60) return 'noite';
      if (total < 12 * 60) return 'manhã';
      if (total < 18 * 60) return 'tarde';
      return 'noite';
    } catch (e) {
      return 'noite';
    }
  };

  const formatDateWithPeriod = dateString => {
    if (!dateString) return '';
    const parts = dateString.split(' às ');
    if (parts.length !== 2) return dateString;

    const [date] = parts;
    return date;
  };

  const formatDateFromInput = dateString => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  const formatDateToInput = dateString => {
    if (!dateString || dateString.length !== 10) return '';
    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  };

  const isWithin30Days = endDateTime => {
    if (!endDateTime) return false;

    try {
      const endDate = moment(endDateTime).local();
      const currentDate = moment();
      const daysDifference = currentDate.diff(endDate, 'days');

      return daysDifference <= 30;
    } catch (e) {
      return false;
    }
  };

  return {
    getPeriodLabel,
    formatDateWithPeriod,
    formatDateFromInput,
    formatDateToInput,
    isWithin30Days,
  };
}
